module.exports = __webpack_public_path__ + "img/fileManager-empty.3383eafd.png";